/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Rule_NofollowInputs */

const en_directory_submit_badge_rule_nofollow = /** @type {(inputs: Directory_Submit_Badge_Rule_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Without the badge, the listing links nofollow.`)
};

const zh_directory_submit_badge_rule_nofollow = /** @type {(inputs: Directory_Submit_Badge_Rule_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未放置徽章时，外链为 nofollow。`)
};

/**
* | output |
* | --- |
* | "Without the badge, the listing links nofollow." |
*
* @param {Directory_Submit_Badge_Rule_NofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_rule_nofollow = /** @type {((inputs?: Directory_Submit_Badge_Rule_NofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Rule_NofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_rule_nofollow(inputs)
	return zh_directory_submit_badge_rule_nofollow(inputs)
});
export { directory_submit_badge_rule_nofollow as "directory.submit.badge.rule_nofollow" }